// Static gradients. "light" and "dark" approximate the hero palettes of the
// WebGL ScrollReactiveBackground — painted on SSR and used as the pre-load /
// failure fallback so the page shows the right colours even if the canvas
// chunk is still loading or was purged by a deploy. Their brightness reverses
// near the bottom to mimic the wave glow, so they only look right UNDER the
// canvas. "dark-flat" is monotonic — for dark pages with no canvas on top,
// where the reversal would show as an unnatural band fixed near the bottom
// of the viewport.
const STATIC_GRADIENTS = {
  light:
    "linear-gradient(180deg, rgb(243, 232, 255) 0%, rgb(232, 225, 254) 20%, rgb(254, 235, 246) 40%, rgb(255, 241, 235) 60%, rgb(237, 237, 251) 80%, rgb(213, 225, 243) 100%)",
  dark: "linear-gradient(180deg, rgb(0, 0, 2) 0%, rgb(1, 3, 10) 17%, rgb(2, 8, 22) 33%, rgb(2, 16, 48) 50%, rgb(2, 30, 95) 67%, rgb(2, 45, 150) 83%, rgb(1, 16, 52) 100%)",
  "dark-flat":
    "linear-gradient(180deg, rgb(0, 0, 2) 0%, rgb(1, 3, 10) 30%, rgb(2, 10, 30) 62%, rgb(2, 24, 76) 100%)",
} as const;

export default function FallbackBackground({
  variant = "light",
}: {
  variant?: "light" | "dark" | "dark-flat";
}) {
  return (
    <div
      className="pointer-events-none fixed inset-0 z-0 h-full w-full"
      style={{ background: STATIC_GRADIENTS[variant] }}
    />
  );
}
